// extracted by mini-css-extract-plugin
export var checkbox = "_5f-0";
export var circle = "_5f-3";
export var horizontalContainer = "_5f-7";
export var sm = "_5f-5";
export var switch0 = "_5f-2";
export var switchDisabled = "_5f-8";
export var switchEnabled = "_5f-1";
export var textSwitchContainer = "_5f-9";
export var textSwitchOption = "_5f-a";
export var textSwitchOptionSelected = "_5f-b";
export var verticalContainer = "_5f-6";
export var xs = "_5f-4";